import { computed, type Ref } from 'vue'

export type PlayEngine = 'legacy' | 'flock'

export const STRATEGY_PLAY_LABEL = 'Strategy play'
// The tag on a Strategy play: who it comes from.
export const STRATEGY_SOURCE_LABEL = 'Strategy agent'
// The steps a Strategy play's sequence can have.
export const STRATEGY_STEP_TYPES = ['email', 'wait', 'linkedin_connect']

interface PlayMaker {
  made_by?: 'user' | 'strategy' | null
  created_by?: { id: string; name: string } | null
}

export function strategyMakerLabel(play: PlayMaker, currentUserId: string | null | undefined): string {
  if (play.made_by !== 'user') return STRATEGY_SOURCE_LABEL
  if (play.created_by && play.created_by.id === currentUserId) return 'Made by you'
  return play.created_by ? `Made by ${play.created_by.name}` : 'Made by a teammate'
}

export function isFlockPlay(play: { engine?: PlayEngine } | null | undefined): boolean {
  return play?.engine === 'flock'
}

// Flock plays choose people from a brief; only their sequence is edited on the classic canvas.
export function usePlayEngine(play: Ref<{ engine?: PlayEngine } | null | undefined>) {
  const isFlock = computed(() => isFlockPlay(play.value))
  return { isFlock }
}
